import {ModalSource, RevocableTrustModalInputs, WillModalInputs} from "../../model/EstateFlowchartTypes";
import React, {ChangeEvent, useEffect} from "react";
import {RadioGroup} from "src/components";
import {useAppSelector} from "../../../store/hooks";
import {familyMembersSelector, getSelectedFlowchart} from "../../slices/EstateFlowChartSlice";
import {getPrimaryAndPartnerMemberNames} from "../../utils/DefUtils";

type WillInputsProps = Readonly<{
    setFormData: Function,
    formData: WillModalInputs
    modalSource: ModalSource
}>
function WillInputs({setFormData, formData, modalSource}: WillInputsProps) {
    const familyMembers = useAppSelector(familyMembersSelector);
    const selectedFlowchart = useAppSelector(getSelectedFlowchart);

    const {primaryWill, partnerWill} = modalSource === ModalSource.AddFlowchart
        ? {primaryWill: undefined, partnerWill: undefined}
        : selectedFlowchart?.willSummary || {};
    const {primaryMemberName, partnerMemberName} = getPrimaryAndPartnerMemberNames(familyMembers);

    const isRadioGroupDisabled = modalSource !== ModalSource.AddFlowchart && (!!primaryWill || !!partnerWill);

    useEffect(() => {
        let defaultWillOwnerId = familyMembers.primaryMember.id;
        if (primaryWill && familyMembers.partnerMember) {
            defaultWillOwnerId = familyMembers.partnerMember.id;
        }

        setFormData((prev: WillModalInputs) => ({
            ...prev,
            willOwner: defaultWillOwnerId,

        }));
    }, [primaryWill, partnerWill, familyMembers, setFormData]);

    const willOwnerValues = familyMembers.partnerMember ?
        [primaryMemberName, partnerMemberName] :
        [primaryMemberName];

    const handleWillOwnerChange = (e: ChangeEvent<HTMLInputElement>) => {
        const willOwnerId = e.target.value === primaryMemberName
            ? familyMembers.primaryMember.id
            : familyMembers.partnerMember?.id;

        setFormData((prev: RevocableTrustModalInputs) => ({
            ...prev,
            willOwner: willOwnerId,
            primaryWill: familyMembers.primaryMember.id === willOwnerId
        }));
    };

    const selectedRadio = formData.willOwner === familyMembers.partnerMember?.id
        ? partnerMemberName
        : primaryMemberName;

    return (
    <div>
            <RadioGroup
                name={'willOwner-radio'}
                label="Who is this will for?"
                className='vertical-radiogroup layout-data-entry-form__field flowchart-modal__field'
                layout='vertical'
                values={willOwnerValues}
                onChange={handleWillOwnerChange}
                selected={selectedRadio}
                disabled={isRadioGroupDisabled}
            />
        </div>
    )
}

export default WillInputs;